module.exports = __webpack_public_path__ + "static/media/DSC09734.cfd8e0a8.jpg";